export const API_URL = {
    'customer-visit-history.all': '/crm/customer-visit-history',
    'customer-visit-history.amount': '/crm/customer-visit-history/amount',
    'customer-visit-history.store': '/crm/customer-visit-history/create',
    'customer-visit-history.update': '/crm/customer-visit-history/update/:id',
    'customer-visit-history.update-ingredient': '/crm/customer-visit-history/update-ingredient/:id',
    'customer-visit-history.delete': '/crm/customer-visit-history/delete/:id',
}
